import {
  House, Briefcase, Camera, ListBullets, Lightning, Calculator, Newspaper,
  Storefront, VideoCamera, ListChecks, Package, Wrench, UserGear, UsersThree,
  ShieldCheck, Tag, ClipboardText, Blueprint
} from "@phosphor-icons/react";

const tabs = [
  { id: "dashboard", label: "Home", icon: House },
  { id: "jobs", label: "Jobs", icon: Briefcase },
  { id: "inspect", label: "Inspect", icon: Camera },
  { id: "materials", label: "Materials", icon: ListBullets },
  { id: "plans", label: "Plans", icon: Blueprint },
  { id: "permits", label: "Permits", icon: ClipboardText },
  { id: "voltage", label: "NCVT", icon: Lightning, highlight: true },
  { id: "calc", label: "Calc", icon: Calculator },
  { id: "camera", label: "Cam", icon: VideoCamera },
  { id: "tasks", label: "Tasks", icon: ListChecks },
  { id: "inventory", label: "Stock", icon: Package },
  { id: "tooltracker", label: "Tools", icon: Tag },
  { id: "safety", label: "OSHA", icon: ShieldCheck },
  { id: "maintenance", label: "Maint.", icon: Wrench },
  { id: "news", label: "News", icon: Newspaper },
  { id: "sponsored", label: "Shop", icon: Storefront },
  { id: "admin", label: "Admin", icon: UserGear },
  { id: "customers", label: "Clients", icon: UsersThree },
];

export default function BottomNav({ active, onNavigate }) {
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E5E5E5] z-[10001]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}>
      <div className="flex items-center overflow-x-auto max-w-5xl mx-auto h-14 px-1"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = active === tab.id;
          return (
            <button key={tab.id} data-testid={`nav-${tab.id}`} onClick={() => onNavigate(tab.id)}
              className={`flex flex-col items-center justify-center gap-0.5 min-w-[42px] px-1 py-1 shrink-0 transition-colors duration-200 ${
                isActive ? "text-[#002FA7]" : "text-[#404040] hover:text-[#0A0A0A]"}`}>
              <div className={tab.highlight && !isActive ? "w-5 h-5 rounded-full bg-[#FFCC00] flex items-center justify-center text-[#0A0A0A]" : tab.highlight && isActive ? "w-5 h-5 rounded-full bg-[#FF5A00] flex items-center justify-center text-white" : ""}>
                <Icon size={tab.highlight ? 12 : 15} weight={isActive ? "duotone" : tab.highlight ? "fill" : "regular"} />
              </div>
              <span className="text-[6px] font-medium tracking-wide leading-none" style={{ fontFamily: "'IBM Plex Mono', monospace" }}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
